import React, { useEffect, useRef, useState } from 'react';
import './Home.css';
import { apiUrl, securityConfig } from '../../config';
import {
  validateEnquiryForm,
  hasValidationErrors,
} from '../../lib/formValidation';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import NextPageCTA from '../../components/NextPageCTA';
import BannerLogo from '../../components/BannerLogo';
import expertsVideo from '../../assets/videos/experts.mp4';
import vivekProfile from '../../assets/images/vivek.png';
import sriniProfile from '../../assets/images/srini.png';
import LaxmanProfile from '../../assets/images/Lakshman.jpeg';
import srkProfile from '../../assets/images/Srk.jpg';
import powerPlantImage from '../../assets/images/image3.jpg';
import oilRefineryImage from '../../assets/images/image10.jpg';
import steelPlantImage from '../../assets/images/image11.jpeg';
import welcomeBackgroundImage from '../../assets/images/image12.jpg';
import insolvencyImage from '../../assets/images/image1.jpg';
import riskAdvisoryImage from '../../assets/images/image6.jpg';
import financialConsultingImage from '../../assets/images/image5.jpg';
import oilRefineryImage2 from '../../assets/images/Oil Refinery.jpg';
// Engineering Services Division Images
import physicalVerificationImg from '../../assets/images/Physical Verification.jpg';
import plantValuationsImg from '../../assets/images/plant valuations.jpg';
import projectMonitoringImg from '../../assets/images/Projectmonitoring.jpg';
import capitalizationImg from '../../assets/images/capitalization.jpg';
import technicalImg from '../../assets/images/Technical.jpg';
import lendersImg from '../../assets/images/lenders.jpg';
// New service images
import valuationImg from '../../assets/images/Valution.jpg';
import bulImg from '../../assets/images/Bulf.webp';
import assetImpairmentImg from '../../assets/images/assetimpairment.webp';
import technicalConsultingImg from '../../assets/images/Technical-Consulting.webp';
import managementServicesImg from '../../assets/images/Solar.jpeg';
import siteVisitImg from '../../assets/images/Sitevisit.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faUser, 
  faClipboardCheck, 
  faChartBar, 
  faClipboardList, 
  faChartLine, 
  faSyncAlt, 
  faExchangeAlt,
  faPhoneAlt,
  faEnvelope,
  faListAlt,
  faComment,
  faPaperPlane,
  faArrowRight,
  faBuilding,
  faBriefcase
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate, Link } from 'react-router-dom';


const Home = () => {
  // References for animation elements
  const sectionsRef = useRef([]);
  const teamVideoRef = useRef(null);
  const teamDescriptionRef = useRef(null);
  const teamParagraphsRef = useRef([]);
  const serviceCardsRef = useRef([]);
  const textContentParagraphsRef = useRef([]);
  const managementCardsRef = useRef([]);
  
  // State for team slider
  const [activeTeamSlide, setActiveTeamSlide] = useState(0);
  
  // State for selected service in callback form
  const [selectedService, setSelectedService] = useState("");
  
  // Team members data with more consistent styling
  const teamMembers = [
    {
      name: "Vivek Challapally",
      position: "Director",
      bio: "Masters in Technology (Mechanical) in Designs from IIT, Kharagpur. Over 45 years of rich Industrial Experience in the field of Project Management, Finance & General Administration.",
      profileImage: vivekProfile
    },
    {
      name: "Srinivasu V",
      position: "Director",
      bio: "Srinivasu V (Srini), a management accountant with 28+ years of experience, blends finance and technology across sectors like manufacturing, IT, and Unicorns. He specializes in logistics, reporting, and business transformation.",
      profileImage: sriniProfile
    },
    {
      name: "S. Radhakrishna",
      position: "Consultant",
      bio: "Masters in Technology (Mechanical) in Designs from IIT, Kharagpur. Over 46 years Experience in Design, Production, Sales, Purchase, Out sourcing & HR.",
      profileImage: srkProfile
    },
    {
      name: "Shivkumar Lakshman",
      position: "Vice President",
      bio: "Shivkumar Lakshman, VP Projects, brings 34+ years of renewable energy experience. He has led 200+ MW of solar EPC execution, aligning technical delivery with client sustainability goals.",
      profileImage: LaxmanProfile
    },
    
  ];

  const navigate = useNavigate();

  useEffect(() => {
    // Intersection Observer for sections
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          
          // Mark text containers as visible for the connecting line effect
          const textContainers = entry.target.querySelectorAll('.text-content, .team-description');
          textContainers.forEach(container => {
            container.classList.add('visible');
          });
          
          // Add a small delay to make content appear progressively
          const contentElements = entry.target.querySelectorAll('.text-content p, .team-description p');
          contentElements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('fade-in');
              // Create a subtle bounce effect with custom timing
              el.style.transitionTimingFunction = 'cubic-bezier(0.34, 1.56, 0.64, 1)';
            }, 400 * index); // Longer stagger for more pronounced sequential effect
          });
          
          // Handle service cards with standard animation
          const serviceCards = entry.target.querySelectorAll('.service-card, .team-card');
          serviceCards.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('fade-in');
            }, 150 * index);
          });
          
          // Animate section headings
          const sectionHeading = entry.target.querySelector('.section-title, .welcome-heading');
          if (sectionHeading) {
            sectionHeading.classList.add('animate-heading');
          }
          
          // Animate underlines
          const underline = entry.target.querySelector('.title-underline, .welcome-underline');
          if (underline) {
            underline.classList.add('animate-underline');
          }
          // Keep sections stable once animated to avoid scroll jitter/shaking.
          sectionObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '-50px 0px -50px 0px' });
    
        
    // Get all section elements and observe them
    const sections = document.querySelectorAll('section');
    sections.forEach(section => {
      sectionsRef.current.push(section);
      sectionObserver.observe(section);
    });

    // Setup hover-only animations for service cards and interactive elements
    const setupHoverAnimations = () => {
      const serviceCards = document.querySelectorAll('.service-card');
      const engineeringCards = document.querySelectorAll('.engineering-service-card');
      
      // Ensure animations only run on actual hover events
      // and not from scroll-triggered visibility changes
      const addHoverListeners = (elements) => {
        elements.forEach(element => {
          element.addEventListener('mouseenter', () => {
            element.classList.add('hover-active');
          });
          
          element.addEventListener('mouseleave', () => {
            element.classList.remove('hover-active');
            // Explicitly stop any running animations
            const animatedElements = element.querySelectorAll('[class*="animate"], [style*="animation"]');
            animatedElements.forEach(el => {
              el.style.animationPlayState = 'paused';
            });
          });
        });
      };
      
      addHoverListeners(serviceCards);
      addHoverListeners(engineeringCards);
    };
    
    // Call hover setup after a small delay to ensure DOM is ready
    setTimeout(setupHoverAnimations, 1000);

    // Animation observers for team video and description
    const elementObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        } else {
          // Remove animation class when out of view
          entry.target.classList.remove('animate');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

    // Observe team video container
    if (teamVideoRef.current) {
      elementObserver.observe(teamVideoRef.current);
    }

    // Observe team description
    if (teamDescriptionRef.current) {
      elementObserver.observe(teamDescriptionRef.current);
    }

    // Paragraphs observer
    const paragraphObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('animate');
          }, 100); // Small delay for better visual effect
        } else {
          // Reset animation when scrolling back up
          entry.target.classList.remove('animate');
        }
      });
    }, { threshold: 0.1 });

    // Observe team paragraphs
    if (teamParagraphsRef.current.length > 0) {
      teamParagraphsRef.current.forEach(paragraph => {
        paragraphObserver.observe(paragraph);
      });
    }

    // Observe welcome section paragraphs
    if (textContentParagraphsRef.current.length > 0) {
      textContentParagraphsRef.current.forEach(paragraph => {
        paragraphObserver.observe(paragraph);
      });
    }

    // Service cards observer
    const cardsObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.classList.add('animate');
          }, 100);
        } else {
          // Reset animation when scrolling back up
          entry.target.classList.remove('animate');
        }
      });
    }, { threshold: 0.1 });

    // Observe service cards
    if (serviceCardsRef.current.length > 0) {
      serviceCardsRef.current.forEach(card => {
        cardsObserver.observe(card);
      });
    }

    // Observe management team cards
    if (managementCardsRef.current.length > 0) {
      managementCardsRef.current.forEach(card => {
        cardsObserver.observe(card);
      });
    }

    // Cleanup
    return () => {
      sectionObserver.disconnect();
      elementObserver.disconnect();
      paragraphObserver.disconnect();
      cardsObserver.disconnect();
    };
  }, []);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    organization: '',
    title: '',
    email: '',
    subject: '',
    otherSubject: '',
    message: ''
  });
  const [showModal, setShowModal] = useState(false);
  const [callbackError, setCallbackError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [isSubmittingCallback, setIsSubmittingCallback] = useState(false);

  const handleChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;
    if (name === 'phone') {
      value = value.replace(/\D/g, '').slice(0, 10);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
    if (fieldErrors[name]) {
      setFieldErrors((prev) => {
        const next = { ...prev };
        delete next[name];
        return next;
      });
    }
    if (callbackError) setCallbackError('');
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const finalSubject = formData.subject === 'Other' ? formData.otherSubject : formData.subject;
  
    // Reset form
    setFormData({
      name: '',
      phone: '',
      organization: '',
      title: '',
      email: '',
      subject: '',
      otherSubject: '',
      message: ''
    });

    setShowModal(true);
    alert("Successfully sent message. We'll get back to you soon");
  };
  const handleCallbackSubmit = async (e) => {
    e.preventDefault();
    setCallbackError('');
    const service = formData.subject === 'Other' ? formData.otherSubject : formData.subject;
    const errors = validateEnquiryForm(formData, {
      nameKey: 'name',
      serviceFieldKey: 'subject',
      resolvedService: service,
    });
    if (formData.subject === 'Other' && !formData.otherSubject.trim()) {
      errors.otherSubject = 'Please specify the service.';
    }
    if (hasValidationErrors(errors)) {
      setFieldErrors(errors);
      return;
    }
    setFieldErrors({});
    setIsSubmittingCallback(true);
    try {
      let captchaToken = '';
      if (securityConfig.turnstileSiteKey && window.turnstile && typeof window.turnstile.execute === 'function') {
        captchaToken = await window.turnstile.execute(securityConfig.turnstileSiteKey, { action: 'callback_form' });
      }
      if (securityConfig.turnstileSiteKey && !captchaToken) {
        setCallbackError('Captcha verification failed. Please refresh and try again.');
        setIsSubmittingCallback(false);
        return;
      }

      const response = await fetch(apiUrl('/api/callback'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          phone_number: formData.phone,
          organization: formData.organization,
          title: formData.title,
          email: formData.email,
          service: service,
          message: formData.message,
          captcha_token: captchaToken,
        }),
      });
      const json = await response.json().catch(() => ({}));

      if (!response.ok || !json.success) {
        const msg =
          (typeof json.message === 'string' && json.message) ||
          `Request failed (${response.status}). Please try again or call +91 40 3517 1118.`;
        setCallbackError(msg);
        setIsSubmittingCallback(false);
        return;
      }
      if (!json.notification_email_sent) {
        const hint = json.mail_failure_hint;
        const graphMsg =
          'We could not deliver the email notification (Microsoft Graph mail). Please try again or call +91 40 3517 1118.';
        const notConfigured =
          'The API server is not configured to send email. Please call +91 40 3517 1118.';
        setCallbackError(
          hint === 'MAIL_NOT_CONFIGURED' ? notConfigured : graphMsg,
        );
        setIsSubmittingCallback(false);
        return;
      }

      setFormData({
        name: '',
        phone: '',
        organization: '',
        title: '',
        email: '',
        subject: '',
        otherSubject: '',
        message: ''
      });
      setFieldErrors({});
      setShowModal(true);
    } catch (error) {
      const reason = String(error?.message || 'Unknown error');
      setCallbackError(`Could not submit callback request (${reason}). Check your connection and API URL, or call +91 40 3517 1118.`);
    } finally {
      setIsSubmittingCallback(false);
    }
  };
  // Function to add refs to arrays
  const addToRefs = (el, refs) => {
    if (el && !refs.current.includes(el)) {
      refs.current.push(el);
    }
  };

  // Enhance smooth scrolling
  useEffect(() => {
    // Enable smooth scrolling for internal links
    const handleLinkClick = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (target) {
        e.preventDefault();
        const id = target.getAttribute('href').slice(1);
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };

    document.addEventListener('click', handleLinkClick);
    
    return () => {
      document.removeEventListener('click', handleLinkClick);
    };
  }, []);
 
  const handleServiceCardClick = (serviceType) => {
    if (serviceType === 'EPC') {
      navigate('/epc');
    } else {
      navigate('/services');
    }
  };

  return (
    <div className="home-container">
      <Navbar />
      
      <div className="home-content">
        <section className="welcome-section" style={{ 
          position: 'relative',
          backgroundColor: 'transparent',
          textAlign: 'left',
          marginTop: '0',
          padding: '0',
          height: '85vh',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${welcomeBackgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7))',
            zIndex: 2
          }}></div>
          
          <div style={{ 
            position: 'absolute', 
            zIndex: 3, 
            top: '20px',
            left: '40px',
            display: 'flex'
          }}>
            <div 
              className="logo-container"
              style={{
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.9), rgba(240, 247, 255, 0.8))',
                borderRadius: '50%',
                padding: '12px',
                boxShadow: '0 8px 20px rgba(26, 115, 232, 0.15)',
                display: 'inline-block',
                border: '2px solid rgba(26, 115, 232, 0.1)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 12px 25px rgba(26, 115, 232, 0.25)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(26, 115, 232, 0.15)';
              }}
            >
              <BannerLogo />
            </div>
          </div>
          
          <div className="welcome-heading-block" style={{ 
            position: 'relative', 
            zIndex: 3, 
            textAlign: 'center',
            marginTop: '60px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '0 20px'
          }}>
            <h2 className="welcome-heading" style={{
              fontSize: '3.5rem',
              fontWeight: '700',
              color: '#333333',
              textTransform: 'uppercase',
              textAlign: 'center',
              textShadow: 'none',
              margin: '0',
              padding: '0 0 20px 0'
            }}>
              WELCOME TO<span style={{
                display: 'block', 
                color: '#0066ff',
                marginTop: '10px'
              }}>VARDAAN RESOURCES PVT. LTD.</span>
            </h2>
            <div className="welcome-underline" style={{ 
              margin: '0 auto',
              width: '300px',
              height: '4px',
              background: '#0066ff',
              borderRadius: '2px',
              boxShadow: 'none'
            }}></div>
          </div>
        </section>

        <section className="about-section" style={{ 
          backgroundColor: '#fff',
          padding: '60px 0',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          minHeight: '60vh' // This ensures some minimum height for better centering
        }}>
          <div className="section-container" style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <h2 className="section-title">About <span style={{ color: '#1a73e8' }}>Us</span></h2>
            <div className="title-underline"></div>
            
            <div className="text-content" style={{ 
              backgroundColor: 'transparent',
              boxShadow: 'none',
              textAlign: 'justify',
              maxWidth: '90%',
              margin: '20px auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <p ref={(el) => addToRefs(el, textContentParagraphsRef)} style={{ 
                backgroundColor: 'transparent', 
                padding: '15px 20px',
                marginBottom: '15px',
                color: '#000000',
                textAlign: 'justify',
                lineHeight: '1.6',
                maxWidth: '1200px'
              }}>
                <strong style={{ color: '#1a73e8' }}>Vardaan Resources Private Limited (VRPL)</strong> is a value-based engineering and financial services company offering comprehensive solutions in Engineering, EPC (Engineering, Procurement, and Construction), and valuation of Fixed Assets (Property, Plant & Equipment – PPE) across a broad spectrum of industries like Steel, Oil, Energy, Power, Fertilizer, Automobile, and General Engineering. The nature of these assignments and client requirements are vastly diverse. Over time, we strategically expanded our service portfolio into EPC – Solar through partner Eco-system.
              </p>
            </div>
          </div>
        </section>
        
        <section className="team-section">
          <div className="section-container">
            <h2 className="section-title">Team <span style={{ color: '#1a73e8' }}>of Experts</span></h2>
            <div className="title-underline"></div>
            
            <div className="team-content-wrapper">
              <div ref={teamVideoRef} className="team-video-container">
                <video 
                  autoPlay 
                  loop 
                  muted 
                  playsInline
                  className="experts-video"
                >
                  <source src={expertsVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              
              <div ref={teamDescriptionRef} className="team-description">
                <p ref={(el) => addToRefs(el, teamParagraphsRef)}><span style={{ color: '#1a73e8' }}>The team at Vardaan</span> consists of highly experienced professionals in the fields of Mechanical, Chemical, Civil, Electrical Engineering and Finance having experience of over 45 years in their respective fields.</p>
                
                <p ref={(el) => addToRefs(el, teamParagraphsRef)}>Many members in VRPL team worked in senior positions in <span style={{ color: '#1a73e8' }}>PSUs/ MNCs</span> and have acquired hands on experience in providing technical and financial services for many projects.</p>
                
                <p ref={(el) => addToRefs(el, teamParagraphsRef)}>A few of the VRPL team members are accredited as <span style={{ color: '#1a73e8' }}>Registered Valuers</span> of Plant & Machinery, Land & Buildings and also as Chartered Engineers.</p>
                
                <p ref={(el) => addToRefs(el, teamParagraphsRef)}>The Company has offered its services to leading corporate houses in India and has been appreciated for the quality and commitment of services rendered.</p>
              </div>
            </div>
          </div>
        </section>
        
        <section className="services-section">
          <div className="section-container">
            <h2 className="section-title">Our Services</h2>
            <div className="title-underline"></div>
            
            <div className="engineering-services-grid">
              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('EPC')}
              >
                <img src={managementServicesImg} alt="Management Services" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Engineering, Procurement & Construction-Solar</h3>
                </div>
              </div>
              
              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={capitalizationImg} alt="Capitalization" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Capitalization of Fixed Assets(PPE)</h3>
                </div>
              </div>
              
              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={plantValuationsImg} alt="Plant Valuations" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Business and Plant Valuations</h3>
                </div>
              </div>
              
              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={physicalVerificationImg} alt="Physical Verification" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Physical Verification of Fixed Assets and Inventory</h3>
                </div>
              </div>
              
              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={technicalImg} alt="Technical & Financial" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Technical & Financial Feasibility Studies</h3>
                </div>
              </div>
              
              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={projectMonitoringImg} alt="Project Monitoring" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Project Monitoring</h3>
                </div>
              </div>
              
              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={lendersImg} alt="Lenders/Owners Engineers" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Lender's/Owner's Engineers</h3>
                </div>
              </div>

              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={valuationImg} alt="Valuation" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Valuation of Fixed Assets</h3>
                </div>
              </div>

              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={bulImg} alt="BUL Assessment" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Technical Assessment of Balance Useful Life</h3>
                </div>
              </div>
              
              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={assetImpairmentImg} alt="Asset Impairment" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Asset Impairment Studies</h3>
                </div>
              </div>
              
              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={technicalConsultingImg} alt="Technical Consulting" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Technical and Financial Consultancy</h3>
                </div>
              </div>

              <div 
                ref={(el) => addToRefs(el, serviceCardsRef)} 
                className="engineering-service-card" 
                onClick={() => handleServiceCardClick('other')}
              >
                <img src={siteVisitImg} alt="Site Visits" className="engineering-service-image" />
                <div className="engineering-service-overlay">
                  <h3 className="engineering-service-title">Site Visits and Inspection Services</h3>
                </div>
              </div>
            </div>
          </div>
        </section>
        
        <section className="callback-section">
          <div className="callback-container">
            <div className="callback-content">
              <div className="callback-image">
              </div>
              <div className="callback-form-container" style={{ overflow: "visible" }}>
                <h2 className="callback-title">Request a <span style={{ color: '#1a73e8' }}>Call Back</span></h2>
                <p className="callback-description">For any queries, please fill the form with valid details and submit. We'll get back to you shortly.</p>
                {callbackError && <p style={{ color: '#c62828', marginBottom: '12px' }}>{callbackError}</p>}
                
                <form className="callback-form" onSubmit={handleCallbackSubmit} noValidate>
                  <div className="form-row">
                    <div className="form-group">
                      <div className={`input-icon-wrapper${fieldErrors.name ? ' input-invalid' : ''}`}>
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faUser} style={{ color: "#1a73e8" }} />
                        </span>
                        <input 
                          type="text" 
                          className="form-input" 
                          name="name"
                          placeholder="Your Name" 
                          value={formData.name}
                          onChange={handleChange}
                          maxLength={100}
                          aria-invalid={Boolean(fieldErrors.name)}
                          aria-describedby={fieldErrors.name ? 'callback-name-error' : undefined}
                        />
                      </div>
                      {fieldErrors.name && (
                        <span id="callback-name-error" className="field-error" role="alert">
                          {fieldErrors.name}
                        </span>
                      )}
                    </div>

                    <div className="form-group">
                      <div className={`input-icon-wrapper${fieldErrors.phone ? ' input-invalid' : ''}`}>
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faPhoneAlt} style={{ color: "#1a73e8" }} />
                        </span>
                        <input 
                          type="tel" 
                          className="form-input" 
                          name="phone"
                          placeholder="Phone Number (10 digits)" 
                          value={formData.phone}
                          onChange={handleChange}
                          inputMode="numeric"
                          pattern="[0-9]{10}"
                          maxLength={10}
                          aria-invalid={Boolean(fieldErrors.phone)}
                          aria-describedby={fieldErrors.phone ? 'callback-phone-error' : undefined}
                        />
                      </div>
                      {fieldErrors.phone && (
                        <span id="callback-phone-error" className="field-error" role="alert">
                          {fieldErrors.phone}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <div className={`input-icon-wrapper${fieldErrors.organization ? ' input-invalid' : ''}`}>
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faBuilding} style={{ color: "#1a73e8" }} />
                        </span>
                        <input 
                          type="text" 
                          className="form-input" 
                          name="organization"
                          placeholder="Your Organization" 
                          value={formData.organization}
                          onChange={handleChange}
                          maxLength={150}
                          aria-invalid={Boolean(fieldErrors.organization)}
                          aria-describedby={fieldErrors.organization ? 'callback-organization-error' : undefined}
                        />
                      </div>
                      {fieldErrors.organization && (
                        <span id="callback-organization-error" className="field-error" role="alert">
                          {fieldErrors.organization}
                        </span>
                      )}
                    </div>

                    <div className="form-group">
                      <div className={`input-icon-wrapper${fieldErrors.title ? ' input-invalid' : ''}`}>
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faBriefcase} style={{ color: "#1a73e8" }} />
                        </span>
                        <input 
                          type="text" 
                          className="form-input" 
                          name="title"
                          placeholder="Your Title" 
                          value={formData.title}
                          onChange={handleChange}
                          maxLength={100}
                          aria-invalid={Boolean(fieldErrors.title)}
                          aria-describedby={fieldErrors.title ? 'callback-title-error' : undefined}
                        />
                      </div>
                      {fieldErrors.title && (
                        <span id="callback-title-error" className="field-error" role="alert">
                          {fieldErrors.title}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <div className={`input-icon-wrapper${fieldErrors.email ? ' input-invalid' : ''}`}>
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faEnvelope} style={{ color: "#1a73e8" }} />
                        </span>
                        <input 
                          type="email" 
                          className="form-input" 
                          name="email"
                          placeholder="Email Address" 
                          value={formData.email}
                          onChange={handleChange}
                          maxLength={254}
                          aria-invalid={Boolean(fieldErrors.email)}
                          aria-describedby={fieldErrors.email ? 'callback-email-error' : undefined}
                        />
                      </div>
                      {fieldErrors.email && (
                        <span id="callback-email-error" className="field-error" role="alert">
                          {fieldErrors.email}
                        </span>
                      )}
                    </div>

                    <div className="form-group">
                      <div className={`input-icon-wrapper${fieldErrors.subject ? ' input-invalid' : ''}`}>
                        <span className="input-icon">
                          <FontAwesomeIcon icon={faListAlt} style={{ color: "#1a73e8" }} />
                        </span>
                        <select 
                          className="form-input" 
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          aria-invalid={Boolean(fieldErrors.subject)}
                          aria-describedby={fieldErrors.subject ? 'callback-subject-error' : undefined}
                        >
                          <option value="" disabled>Select Service</option>
                          <option value="Capitalization">Capitalization</option>
                          <option value="Valuation">Valuation</option>
                          <option value="Assessment of Useful Life">Assessment of Useful Life</option>
                          <option value="Physical Verification">Physical Verification</option>
                          <option value="Balanced Useful Life">Balance Useful Life</option>
                          <option value="(EPC)">Engineering, Procurement & Construction - Solar</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      {fieldErrors.subject && (
                        <span id="callback-subject-error" className="field-error" role="alert">
                          {fieldErrors.subject}
                        </span>
                      )}
                    </div>
                  </div>

                  {formData.subject === "Other" && (
                    <div className="form-row" style={{ marginBottom: "15px" }}>
                      <div className="form-group" style={{ width: '100%' }}>
                        <div className={`input-icon-wrapper${fieldErrors.otherSubject ? ' input-invalid' : ''}`}>
                          <span className="input-icon">
                            <FontAwesomeIcon icon={faListAlt} style={{ color: "#1a73e8" }} />
                          </span>
                          <input 
                            type="text" 
                            className="form-input" 
                            name="otherSubject"
                            placeholder="Please specify service" 
                            value={formData.otherSubject}
                            onChange={handleChange}
                            maxLength={80}
                            aria-invalid={Boolean(fieldErrors.otherSubject)}
                            aria-describedby={fieldErrors.otherSubject ? 'callback-other-subject-error' : undefined}
                          />
                        </div>
                        {fieldErrors.otherSubject && (
                          <span id="callback-other-subject-error" className="field-error" role="alert">
                            {fieldErrors.otherSubject}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="form-group" style={{ marginBottom: "15px" }}>
                    <div className={`input-icon-wrapper${fieldErrors.message ? ' input-invalid' : ''}`}>
                      <span className="input-icon textarea-icon">
                        <FontAwesomeIcon icon={faComment} style={{ color: "#1a73e8" }} />
                      </span>
                      <textarea 
                        className="form-textarea" 
                        name="message"
                        rows="3"
                        placeholder="Your Message" 
                        value={formData.message}
                        onChange={handleChange}
                        maxLength={2000}
                        aria-invalid={Boolean(fieldErrors.message)}
                        aria-describedby={fieldErrors.message ? 'callback-message-error' : undefined}
                      ></textarea>
                    </div>
                    {fieldErrors.message && (
                      <span id="callback-message-error" className="field-error" role="alert">
                        {fieldErrors.message}
                      </span>
                    )}
                  </div>

                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    width: '100%', 
                    marginTop: '20px',
                    position: 'static'
                  }}>
                    <button type="submit" disabled={isSubmittingCallback} style={{
                      background: 'linear-gradient(135deg, #1a73e8, #4fc3f7)',
                      color: 'white',
                      padding: '12px 30px',
                      border: 'none',
                      borderRadius: '8px',
                      fontWeight: '600',
                      fontSize: '1rem',
                      cursor: 'pointer',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '10px',
                      boxShadow: '0 8px 15px rgba(26, 115, 232, 0.2)',
                      minWidth: '140px'
                    }}>
                      <FontAwesomeIcon icon={faPaperPlane} style={{ color: "#fff" }} /> {isSubmittingCallback ? 'SUBMITTING...' : 'SUBMIT'}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        
        <section className="locations-section">
          <div className="section-container">
            <h2 className="section-title">Typical <span style={{ color: '#1a73e8' }}>Locations</span> Where We Worked</h2>
            <div className="title-underline"></div>
            
            <div className="locations-grid">
              <div className="location-image-container" style={{ '--animation-order': 1 }}>
                <img src={powerPlantImage} alt="Power Plant" className="location-image" />
                <div className="location-name">Power Plant</div>
              </div>
              
              <div className="location-image-container" style={{ '--animation-order': 2 }}>
                <img src={oilRefineryImage} alt="Chemical Plant" className="location-image" />
                <div className="location-name">Chemical Plant</div>
              </div>
              
              <div className="location-image-container" style={{ '--animation-order': 3 }}>
                <img src={steelPlantImage} alt="Steel Plant" className="location-image" />
                <div className="location-name">Steel Plant</div>
              </div>

              <div className="location-image-container" style={{ '--animation-order': 4 }}>
                <img src={oilRefineryImage2} alt="Oil Refinery" className="location-image" />
                <div className="location-name">Oil Refinery</div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* Journey Navigation - Next Page CTA */}
      <NextPageCTA 
        title="Discover Mission" 
        description="Our vision, mission, and the core values that drive our commitment to excellence in engineering services."
        nextPage={{
          path: "/mission",
          label: "Explore Mission"
        }}
        headingText="Embark Your Journey"
      />
      {showModal && (
          <div className="modal-overlay">
            <div className="success-modal">
              <div className="modal-icon">
                <i className="fas fa-check-circle"></i>
              </div>
              <h3>Thank You!</h3>
              <p>Your message has been sent successfully. We'll get back to you soon.</p>
              <p className="response-time">Expected response time: 24–48 hours</p>
              <button className="modal-close-btn" onClick={() => setShowModal(false)}>
                Close
              </button>
            </div>
          </div>
        )}

      <Footer />
    </div>
  );
};

export default Home; 